export default __webpack_public_path__ + "static/media/schedule-bottom-right.eeab9c20.svg";